import TrendingUp from '@mui/icons-material/TrendingUp';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { LookalikeSegmentSimilarityApi } from '@openx/types/segments.ts';
import { useTranslation } from 'react-i18next';
import { calculateIncrease } from '../../../../utils/calculateIncrease.ts';

type NameCellProps = {
  segment: LookalikeSegmentSimilarityApi['segment'];
  seed: LookalikeSegmentSimilarityApi['segment'];
  type: string;
};

export const NameCell = ({ segment, seed, type }: NameCellProps) => {
  const increase = calculateIncrease(segment.reach, seed.reach);
  const showIncrease = type !== 'Seed' && increase && increase !== '1';

  return (
    <Stack
      sx={{
        justifyContent: 'center',
        minHeight: 60,
      }}
    >
      <Typography variant="body2Bold">{segment.name}</Typography>
      {showIncrease && <IncreaseText increase={increase} />}
    </Stack>
  );
};

const IncreaseText = ({ increase }: { increase: string }) => {
  const { t } = useTranslation();

  return (
    <Typography
      component="span"
      variant="body2"
      sx={{
        color: 'text.secondary',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography component="span">{t('Increase')}:</Typography>
      <Typography component="span" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {increase}x <TrendingUp color="success" sx={{ width: 14, height: 14 }} />
      </Typography>
    </Typography>
  );
};
